export type Descripted<T> = {
  [K in keyof T]: {
    readonly id: T[K];
    description: string;
  };
}[keyof T];

/**
 * Helper to produce an array of enum descriptors.
 * @param enumeration Enumeration object.
 * @param separatorRegex Regex that would catch the separator in your enum key.
 */
export function enumToDescriptedArray<T>(enumeration: T, separatorRegex = /_/g): Descripted<T>[] {
  return (Object.keys(enumeration as object) as Array<keyof T>)
    .filter(key => isNaN(Number(key)))
    .filter(key => typeof enumeration[key] === 'number' || typeof enumeration[key] === 'string')
    .map(key => ({
      id: enumeration[key],
      description: String(key).replace(separatorRegex, ' '),
    }));
}

// convertTypeToEnum START
type ConvertTypeToEnum<T extends string> = {
  [K in T]: K;
};

export function convertTypeToEnum<T extends string>(values: T[]): ConvertTypeToEnum<T> {
  const enumValues = {} as ConvertTypeToEnum<T>;

  values.forEach(value => {
    enumValues[value] = value as T; // Asserting that the index is a key of ConvertTypeToEnum<T>
  });

  return enumValues;
}
// convertTypeToEnum END
